const params = {
	state: {
        dataanalysisComicviewTopicId: '', // 数据分析-》漫画数据-》章节分析topicid参数
        dataanalysisComicviewComicId: '' // 数据分析-》漫画数据-》章节分析comicid参数
	},

  	mutations: {
		SET_DATAANALYSISCOMICVIEWIDS: (state, oId) => {
            state.dataanalysisComicviewTopicId = oId.topicId
            state.dataanalysisComicviewComicId = oId.comicId
		},
  	},

  	actions: {
		setDataanalysisComicviewIds({ commit }, oId) {
			commit('SET_DATAANALYSISCOMICVIEWIDS', oId)
		}
	}
}

export default params
